module.exports = __webpack_public_path__ + "img/loader.141ded36.svg";